import React from 'react';

import { regPlatformTheme } from '@/styles/regPlatformTheme';

import styled from '@emotion/styled';
import { Link } from '../../../../components/router/Link';
import { usePathname } from '../../../../hooks/useRouter';
import cn from 'classnames';

import { ApplicationSwitcherWrapper } from './ApplicationSwitcherWrapper';

const routes = [
  { path: '/customers', text: 'Customers' },
  { path: '/sessions', text: 'Sessions' },
];

export const NavigationHeader = () => {
  const currentRoute = usePathname();

  return (
    <HeaderContainer>
      <HeaderContent>
        <ApplicationSwitcherWrapper />
        <Navigation>
          {routes.map(({ path, text }, index) => (
            <Link key={index} href={path} className={cn({ active: currentRoute === `/enrolments${path}` })}>
              {text}
            </Link>
          ))}
        </Navigation>
      </HeaderContent>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  background-color: ${regPlatformTheme.colors.indigo};
  color: white;
  font-size: 16px;
  padding: 12px 0;
`;

const HeaderContent = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  max-width: var(--max-content-width);
  margin: 0 auto;
  & > span button {
    padding-left: 0;
  }
`;

const Navigation = styled.nav`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  gap: 24px;

  a {
    position: relative;
    color: white;
    text-decoration: none;

    &:hover,
    &:active {
      color: white;
    }

    &.active {
      font-weight: bold;

      :after {
        border: 2px solid #5d71ad;
        border-radius: 2px;
        bottom: -2px;
        content: '';
        left: 0;
        position: absolute;
        width: 100%;
      }
    }
  }
`;
